import { useTranslation } from 'react-i18next';

import { Container, CardInfo, Image } from './styles';
import logoBrasil from '../../../img/country.svg';
import logoPaint from '../../../img/paint.svg';
import logoSex from '../../../img/sex.svg';
import Carousel from '../../Carousel';

export default function SliderCards({ click }) {
  const { t } = useTranslation();

  return (
    <Container>
      <Carousel
        autoPlay
        showArrows
        swipeable
        emulateTouch
        infiniteLoop
        stopOnHover
      >
        <CardInfo onClick={() => click('technology')}>
          <Image>
            <img src={logoPaint} alt="Tecnologia" width="60" height="60" />
          </Image>
          <div className="content">
            <header>{t('Alexandrite NdYAG')}</header>
            <div className="description">
              {t(
                'Exclusividade que une os melhores lasers do mundo e aplica em mais peles',
              )}
            </div>
          </div>
        </CardInfo>
        <CardInfo onClick={() => click('genre')}>
          <Image>
            <img src={logoSex} alt="Gênero" width="60" height="60" />
          </Image>
          <div className="content">
            <header>{t('Gênero não define preço')}</header>
            <div className="description">
              {t(
                'A primeira e única Rede de Depilação a Laser do Brasil sem distinção de preço por gênero',
              )}
            </div>
          </div>
        </CardInfo>
        <CardInfo onClick={() => click('portability')}>
          <Image>
            <img src={logoBrasil} alt="Portabilidade" width="60" height="60" />
          </Image>
          <div className="content">
            <header>{t('Portabilidade_title')}</header>
            <div className="description">
              {t(
                'Faça seu tratamento em qualquer clínica Vialaser, sem custos adicionais',
              )}
            </div>
          </div>
        </CardInfo>
      </Carousel>
    </Container>
  );
}
